module.exports = __webpack_public_path__ + "static/media/messages.08e47c30.svg";